import React from "react";
import Lightbox from "react-spring-lightbox";
import styled from "styled-components";
import  ArrowButton from "./ArrowButtons";

const CoolLightbox = ({
  images,
  currentImageIndex,
  setCurrentIndex,
  isOpen,
  onClose
}) => {
  const gotoPrevious = () =>
    currentImageIndex > 0 && setCurrentIndex(currentImageIndex - 1);

  const gotoNext = () =>
    currentImageIndex + 1 < images.length &&
    setCurrentIndex(currentImageIndex + 1);

  return (
    <StyledLightbox
      isOpen={isOpen}
      onPrev={gotoPrevious}
      onNext={gotoNext}
      onClose={onClose}
      images={images}
      currentIndex={currentImageIndex}
      singleClickToZoom
      renderPrevButton={({ canPrev }) => (
        <ArrowButton
          position="left"
          onClick={gotoPrevious}
          disabled={!canPrev}
        />
      )}
      renderNextButton={({ canNext }) => (
        <ArrowButton position="right" onClick={gotoNext} disabled={!canNext} />
      )}
      pageTransitionConfig={{
              from: { transform: "scale(1)", opacity: 0 },
              enter: { transform: "scale(1)", opacity: 1 },
              leave: { transform: "scale(1)", opacity: 0 },
              config: { mass: 1, tension: 320, friction: 32 }
            }}
    />
  );
};


export default CoolLightbox;

const StyledLightbox = styled(Lightbox)`
  background: rgb(0,0,0,0.6);
`;
